import Vue from 'vue';
import Vuex from 'vuex';

import user from './modules/userStore.js';
import data from './modules/dataStore.js';
Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
		showMenu: true,
		showProfile: true,
		countries: null
	},
	getters:{},
	mutations: {
	},
	modules: {
		user,
		data
		// Add modules when seperate store "states" are needed for overview purposes.
	}
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js